<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 296.4403 283.19241"
  >
    <path
      d="M226.74934,167.36342s-32.59999,20.49056-33.55601,18.49816,30.55496-21.4992,30.55496-21.4992c0,0,0-9.00314,6.00209-12.00418s10.50366,0,12.00418,3.00105,1.50052,7.50262-1.50052,10.50366-13.50471,1.50052-13.50471,1.50052Z"
      fill="#b06b29"
    />
    <ellipse
      cx="232.48886"
      cy="156.89465"
      rx="6.60928"
      ry="7.43726"
      transform="translate(-18.63839 31.98627) rotate(-7.56804)"
      fill="#f26422"
    />
    <path
      d="M97.69735,94.2806S4.66492,46.26386,.16335,77.77485s85.52981,37.51308,85.52981,37.51308c0,0-4.50157,13.50471-1.50052,27.00941s12.00418,25.50889,12.00418,25.50889c0,0-12.00418,21.00732-16.50575,37.51308s-3.00105,33.01151-3.00105,33.01151c0,0-25.50188,13.0619-14.99822,32.5687,10.85901,20.16674,34.50502,9.44594,34.50502,9.44594,0,0,30.01046,4.50157,51.01778,0,21.00732-4.50157,51.01778-21.00732,48.01674-31.51098s-16.50575,1.50052-16.50575,1.50052c0,0,16.50575-24.00837,3.00105-33.01151-13.50471-9.00314-21.00732,6.00209-21.00732,6.00209l1.50052-10.50366s45.01569-13.50471,40.51412-31.51098-39.0136,6.00209-39.0136,6.00209l-9.00314-9.00314s28.50994-6.00209,31.51098-33.01151c3.00105-27.00941-16.50575-45.01569-25.50889-49.51726s-34.51203-7.50262-34.51203-7.50262c0,0-30.01046-100.53504-57.01987-87.03034-27.00941,13.50471,28.50994,93.03243,28.50994,93.03243Z"
      fill="#faddb4"
    />
    <g>
      <circle
        cx="149.4724"
        cy="118.59642"
        r="6.75235"
      />
      <circle
        cx="146.47136"
        cy="120.09695"
        r="2.25078"
        fill="#fff"
      />
    </g>
    <ellipse
      cx="156.86834"
      cy="132.69666"
      rx="9.42992"
      ry="7.9695"
      transform="translate(-48.59136 131.15063) rotate(-39.79712)"
      fill="#fac4c0"
    />
    <ellipse
      cx="177.98234"
      cy="119.34669"
      rx="5.25183"
      ry="6.00209"
      transform="translate(-32.26103 160.80835) rotate(-45)"
      fill="#e7858c"
    />
    <path
      d="M176.51918,134.58857c-3.99675,0-6.31568-1.70641-6.42704-1.79066l1.80532-2.39732-.90266,1.19866,.89094-1.20745c.09378,.06814,2.32918,1.63827,6.27831,1.07777,3.95866-.5583,5.66653-2.68087,5.73686-2.77099l2.38853,1.81704c-.09745,.12968-2.453,3.18495-7.7063,3.92568-.72975,.10257-1.4192,.14727-2.06395,.14727Z"
    />
    <path
      d="M96.20383,111.84407S22.67821,66.82838,18.17664,83.33413s66.02301,28.50994,78.0272,28.50994Z"
      fill="#f8a697"
    />
    <path
      d="M216.24568,209.37807s-18.00628,1.50052-18.00628,6.00209,12.00418,12.00418,51.01778,12.00418,46.79372-6.01496,46.51621-9.00314c-.38896-4.18862-13.89064-8.68108-43.51517-7.50262-29.98674,1.19289-36.01255-1.50052-36.01255-1.50052Z"
      fill="#f9f2d0"
    />
    <path
      d="M229.75038,258.89533c1.50052,1.50052,28.50994,1.50052,31.51098,0s6.00209-7.50262,9.00314-7.50262,9.00314,0,15.00523-3.00105,9.00314-12.00418,10.50366-16.50575,0-12.00418,0-12.00418l-97.534-3.00105s-3.00105,21.00732,4.50157,28.50994c7.50262,7.50262,18.00628,6.00209,21.00732,7.50262s6.00209,6.00209,6.00209,6.00209Z"
      fill="#f9f2d0"
    />
    <path
      d="M223.74829,207.87754s-3.00105-3.00105-6.00209,0-1.50052,6.00209-1.50052,6.00209c0,0-10.50366,0-10.50366,3.00105s9.00314,9.00314,45.01569,9.00314,37.51308-6.00209,37.51308-7.50262-3.00105-3.00105-3.00105-3.00105c0,0,3.00105-1.50052,1.50052-4.50157s-6.00209-1.50052-6.00209-1.50052c0,0,0-3.00105-1.50052-4.50157s-4.50157-1.50052-4.50157-1.50052c0,0-1.50052-4.50157-3.00105-6.00209s-9.00314,0-9.00314,0c0,0,0-4.50157-4.50157-4.50157s-4.50157,3.00105-4.50157,3.00105c0,0-1.50052-4.50157-6.00209-3.00105s-3.00105,6.00209-3.00105,6.00209c0,0-4.50157-3.00105-10.50366-1.50052s-1.50052,7.50262-1.50052,7.50262c0,0-3.00105-4.50157-7.50262-3.00105s-1.50052,6.00209-1.50052,6.00209Z"
      fill="#fdb725"
    />
    <ellipse
      cx="233.50169"
      cy="213.97342"
      rx="5.90831"
      ry="5.25183"
      transform="translate(-47.08403 360.87242) rotate(-70.13518)"
      fill="#f26422"
    />
    <ellipse
      cx="271.54422"
      cy="200.08727"
      rx="4.66664"
      ry="4.14812"
      transform="translate(-23.98681 37.50624) rotate(-7.56804)"
      fill="#f26422"
    />
    <path
      d="M250.75771,216.88068s2.18258-3.00105,6.54774-1.50052,5.45645,3.00105,5.45645,4.50157-2.18258,1.50052-5.45645,1.50052-5.45645-1.50052-6.54774-4.50157Z"
      fill="#ffd748"
    />
    <path
      d="M269.81467,214.94285s-.89544-3.38424,2.69318-4.92298,5.29271-1.13897,6.36861-.09302-.18046,2.33829-2.065,4.27681-4.21681,2.18492-6.99679,.7392Z"
      fill="#ffd748"
    />
    <path
      d="M258.16276,198.22684s3.36919,.95048,2.8686,4.82287-1.71158,5.1362-3.15938,5.53048-1.9214-1.34477-2.6318-3.95334,.26379-4.74191,2.92258-6.4Z"
      fill="#ffd748"
    />
    <path
      d="M243.46614,205.01199s2.66168-1.87347,3.74741,.68686c1.08573,2.56034,.72152,4.14651-.126,5.40797s-1.81415,.61202-3.2641-.36214-1.56905-2.88506-.35731-5.73269Z"
      fill="#ffd748"
    />
    <ellipse
      cx="238.75352"
      cy="204.12624"
      rx="1.50052"
      ry="2.25078"
      transform="translate(-49.46738 79.22836) rotate(-17.10028)"
      fill="#d97827"
    />
    <ellipse
      cx="226.16993"
      cy="205.9334"
      rx="1.50052"
      ry="2.25078"
      transform="translate(-76.45929 161.47037) rotate(-33.96041)"
      fill="#d97827"
    />
    <ellipse
      cx="242.67569"
      cy="217.034"
      rx="1.50052"
      ry="1.3472"
      fill="#d97827"
    />
    <ellipse
      cx="263.51529"
      cy="203.93077"
      rx="1.50052"
      ry="2.25078"
      transform="translate(-7.70231 10.36146) rotate(-2.22015)"
      fill="#d97827"
    />
    <ellipse
      cx="266.69461"
      cy="220.15787"
      rx="1.50052"
      ry="1.3472"
      fill="#d97827"
    />
    <path
      d="M249.25718,229.63513c-44.90066,0-51.38778-8.95625-51.64202-9.33724l1.24116-.84331c.06228,.08719,6.72964,8.68003,50.40087,8.68003,42.90924,0,45.34979-7.47551,45.36884-7.55097l1.48001,.24252c-.12016,.90119-2.45813,8.80898-46.84885,8.80898Z"
      fill="#c9c69b"
    />
    <path
      d="M248.78461,235.4372c-44.90066,0-51.38778-8.95625-51.64202-9.33724l1.24116-.84331c.06228,.08719,6.72964,8.68003,50.40087,8.68003,42.90924,0,45.34979-7.47551,45.36884-7.55097l1.48001,.24252c-.12016,.90119-2.45813,8.80898-46.84885,8.80898Z"
      fill="#c9c69b"
    />
    <path
      d="M158.47994,246.95635c-.06301-.72022-1.50272-17.71687,1.565-24.38716l1.36278,.62717c-2.9014,6.30982-1.44777,23.4574-1.43312,23.62957l-1.49466,.13042Z"
      fill="#ceb393"
    />
    <path
      d="M96.1357,280.60968l-.72242-1.31589c3.85242-2.11377,6.13984-11.43709,6.16182-11.53087l1.45949,.35169c-.09891,.40957-2.46692,10.06259-6.89889,12.49508Z"
      fill="#ceb393"
    />
  </svg>
</template>
